module.exports = __webpack_public_path__ + "static/media/max3d.2903099d.png";